import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';

/** Display title used for template list ordering (matches TemplateCard). */
export function getTemplateDisplayTitle(
  template: TemplateEntityV1beta3,
): string {
  return template.metadata.title || template.metadata.name;
}

/** Case-insensitive alphabetical compare for template entities. */
export function compareTemplatesAlphabetically(
  a: TemplateEntityV1beta3,
  b: TemplateEntityV1beta3,
): number {
  return getTemplateDisplayTitle(a).localeCompare(
    getTemplateDisplayTitle(b),
    undefined,
    { sensitivity: 'base' },
  );
}
